import type {BasePanel} from '@Components/panel/panel.types';
import type {AddAiItemPopUpSubPanel} from '@Components/add-ai-item-button/components/add-ai-item-dropdown-popup-content/add-ai-item-dropdown-popup-content.types';

export const AI_OPTIONS_HEIGHT = '360px';
export const AI_SUBTITLES_HEIGHT = '390px';
export const AI_SUBTITLES_HEIGHT_PAYG = '450px';
export const AI_IMAGE_HEIGHT = '750px';
export const AI_VOICE_HEIGHT = '350px';

export enum AiOption {
  DEFAULT = 'DEFAULT',
  AI_IMAGE = 'AI_IMAGE',
  AI_SUBTITLES = 'AI_SUBTITLES',
  AI_VOICE = 'AI_VOICE',
}

export interface AiOptionsProps extends BasePanel {
  showNewAiFeaturePulse: AiOptionsSubpanels;
  defaultPanel?: AiOption;
  onClose(): void;
  onDone(): void;
}

export type AiOptionsSubpanels = AddAiItemPopUpSubPanel[];
